import(/* webpackMode: "eager" */ "/tmp/8df2af3222b7377/src/app/template.tsx");
